
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `Daha iyi bir deneyim ve kolay erişim için Ana Ekranınıza ekleyin.`,
's224cbcec014ef6b5': `Gezinme çubuğunda Paylaş'a basın`,
's37a9e8aec5713460': `Daha Fazla`,
's386eca8362ff6155': `Paylaş simgesi yoksa Daha Fazla'ya basın`,
's4e1e10a6ca408245': `"Ana Ekrana Ekle"ye dokunun`,
's6196153c4b0c1ea0': `Yükle`,
's633502f7cff4f847': `Tarayıcı menünüzü açın`,
's681e399d63311fba': `Galeriyi Göster`,
's7f0591f08e318eda': `Paylaş menüsünde Daha Fazla'ya basın`,
's8114bd55cae5a22b': `Dock’a ekleye basın`,
's922329d6f6213590': `Dock’a Ekle`,
's9af56bf005b49c74': `"Ana Ekrana Ekle" seçeneğine kadar aşağı kaydırın`,
'sa5ef80b4bb9b39f8': `Küçült`,
'sba52286c21552a4e': `Daha iyi bir deneyim ve kolay erişim için cihazınıza yükleyin.`,
'sc16e00a7a8b2fde2': `Geri`,
'scdaf4bbff76674c8': `Ana Ekrana Ekle`,
'se0e473adfda8066c': `Ana tarayıcınızda açın`,
'se740f75b95a51807': `Daha iyi bir deneyim ve kolay erişim için Dock’a ekleyin.`,
'sfea652f6580ff086': `Bu site uygulama işlevselliğine sahiptir.`,
    };
  